import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';
import { useNotification } from '../../../../contexts/NotificationContext';

/**
 * Unified Inventory service hook — Add or Edit based on item_id presence.
 */
export const useInventory = (item_id) => {
  const { showNotification } = useNotification();
  const isEdit = !!item_id;
  const [loading, setLoading] = useState(isEdit);
  const [existingData, setExistingData] = useState(null);

  useEffect(() => {
    if (!isEdit) return;
    axios.get(`${API_BASE_URL}/inventory/${item_id}`)
      .then(res => setExistingData(res.data))
      .catch(() => showNotification('error', 'Failed to fetch inventory item details.'))
      .finally(() => setLoading(false));
  }, [item_id, isEdit, showNotification]);

  const submit = async (payload) => isEdit
    ? axios.put(`${API_BASE_URL}/inventory/${item_id}`, payload)
    : axios.post(`${API_BASE_URL}/add_inventory`, payload);

  return { isEdit, loading, existingData, submit };
};

/**
 * Inventory List service hook — fetch all + delete.
 */
export const useInventoryList = () => {
  const { showNotification } = useNotification();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/get_inventory`, { withCredentials: true })
      .then(res => setItems(Array.isArray(res.data.data) ? res.data.data : Array.isArray(res.data) ? res.data : []))
      .catch(() => showNotification('error', 'Failed to fetch inventory items.'))
      .finally(() => setLoading(false));
  }, [showNotification]);

  const deleteItem = async (item_id) => {
    const res = await axios.delete(`${API_BASE_URL}/inventory/${item_id}`);
    if (res.status === 200) setItems(prev => prev.filter(i => i.item_id !== item_id));
  };

  return { items, loading, deleteItem };
};
